export default (store) => ({
  path : '/users',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'UserSearch' */
      './components/UserSearch'
    ).then(module => {
      cb(null, module.default)
    })
  }
})